<template>
  <div class="entity-child-layout">
    <main class="entity-child-layout__main">
      <el-card>
        <slot />
      </el-card>
    </main>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'EntityChildLayout',
})
</script>

<style lang="scss">
.entity-child-layout {
  padding-right: 0;
  margin-bottom: 30px;

  @include media-breakpoint-up(lg) {
    display: flex;
    justify-content: center;
  }

  &__main {
    position: relative;
    overflow: visible;

    @include media-breakpoint-up(lg) {
      flex-grow: 1;
      // No wider than the page allows, whatever it holds (a wide table in a description or comment scrolls or shrinks)
      min-width: 0;
    }

    .el-card {
      overflow: visible;

      .el-card__body {
        padding: 0 !important;
      }

      @include media-breakpoint-down(sm) {
        border-radius: 0 !important;
      }
    }
  }
}
</style>
